import { GridOptions } from '@amzn/gft-ag-grid-enterprise';
import { createId } from '@paralleldrive/cuid2';

/**
 * Shared AG Grid defaults applied to all grids in the application.
 * Spread into each `<AurigaGrid>` or merge into `gridOptions`.
 */
export const globalGridDefaults: GridOptions = {
  accentedSort: true,
  suppressContextMenu: true,
  suppressMovableColumns: true,
  suppressCellFocus: true,
  /*
   AG Grid injects inline <style> tags for its themes; the nonce allows them through strict CSP.
   See: https://www.ag-grid.com/javascript-data-grid/security/#style-src
  */
  styleNonce: createId(),
};
